import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { isServer, isCookieAccepted } from '../../util/cookies';
import { useDispatch } from 'react-redux';
import { handleAffiliation } from '../../ducks/user.duck';

const AffilaeTrackingTag = () => {
  const [affiliateID, setAffiliateID] = useState(null);
  const [isSet, setIsSet] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSet) return;

    const checkAffiliateID = () => {
      if (window?.AeTracker?.affiliateID !== undefined && window?.AeTracker.affiliateID !== affiliateID) {
        setAffiliateID(window.AeTracker.affiliateID);
        handleAffiliateIDChange(window.AeTracker.affiliateID);
      }
    };
    const intervalId = setInterval(checkAffiliateID, 1000);
    return () => clearInterval(intervalId);
  }, [affiliateID, isSet]);

  const handleAffiliateIDChange = (newAffiliateID) => {
    console.log('swimmy ae changed:', newAffiliateID);
    setIsSet(true);
    dispatch(handleAffiliation());
  };
  if (isServer()) return null;
  if (!isCookieAccepted('swimmy_affilaeAccepted')) return null;

  return (
    <div>
      <Helmet>
        <script type="text/javascript">
          {`var _ae = {
              "pid":"643514e954740a0e424adf4b",
            };
              (function() {
              if (typeof window === 'undefined') return;

              var element = document.createElement('script'); element.type = 'text/javascript'; element.async = true;
              element.src = '//static.affilae.com/ae-v3.5.js';
              var scr = document.getElementsByTagName('script')[0]; scr.parentNode.insertBefore(element, scr);
            })();`}
        </script>
      </Helmet>
    </div>
  );
};


export default AffilaeTrackingTag;
